// GivePointPage.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchAuthSession } from "@aws-amplify/auth";

const API_BASE_URL = "https://api.cupvisor.org";

function GivePointPage({ user, signOut }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [jwtToken, setJwtToken] = useState("");
  const [responseData, setResponseData] = useState(null);

  // Extract joinToken from URL.
  const queryParams = new URLSearchParams(location.search);
  const joinToken = queryParams.get("joinToken");

  useEffect(() => {
    async function loadSession() {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();
        setJwtToken(token);
      } catch (err) {
        console.error("Error loading session:", err);
      }
    }
    loadSession();
  }, [user]);

  useEffect(() => {
    async function givePoint() {
      if (!jwtToken || !joinToken) return;
      try {
        const url = `${API_BASE_URL}/vendor/give-point?joinToken=${encodeURIComponent(joinToken)}`;
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          "Accept": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        if (!res.ok) {
          throw new Error(`API returned status ${res.status}`);
        }
        const data = await res.json();
        setResponseData(data);
        // After 2 seconds, redirect back to the vendor portal (e.g. /vendors) with a message.
        setTimeout(() => {
          navigate("/vendors", { state: { message: "Point updated" } });
        }, 2000);
      } catch (err) {
        console.error("Error giving point:", err);
        setResponseData({ error: err.message });
        setTimeout(() => {
          navigate("/vendors", { state: { message: "Error: " + err.message } });
        }, 2000);
      }
    }
    givePoint();
  }, [jwtToken, joinToken, navigate]);

  return (
    <div className="container mt-4">
      <h2>Processing the point update...</h2>
      {responseData ? (
        <div className="alert alert-info mt-3">
          <pre>{JSON.stringify(responseData, null, 2)}</pre>
        </div>
      ) : (
        <p>Please wait while we update the loyalty card...</p>
      )}
    </div>
  );
}

export default GivePointPage;
